import * as yup from 'yup';

// 로그인 검증 스키마
export const loginSchema = yup.object({
  email: yup
    .string()
    .required('이메일을 입력해주세요')
    .email('유효한 이메일 주소를 입력해주세요')
    .trim(),
  password: yup
    .string()
    .required('비밀번호를 입력해주세요')
    .min(4, '비밀번호는 최소 4자 이상이어야 합니다')
}).required();

// 회원가입 검증 스키마
export const signupSchema = yup.object({
  name: yup
    .string()
    .required('이름을 입력해주세요')
    .min(2, '이름은 최소 2자 이상이어야 합니다')
    .max(50, '이름은 최대 50자까지 입력 가능합니다')
    .trim(),
  email: yup
    .string()
    .required('이메일을 입력해주세요')
    .email('유효한 이메일 주소를 입력해주세요')
    .trim(),
  password: yup
    .string()
    .required('비밀번호를 입력해주세요')
    .min(6, '비밀번호는 최소 6자 이상이어야 합니다'),
  confirmPassword: yup
    .string()
    .required('비밀번호 확인을 입력해주세요')
    .oneOf([yup.ref('password')], '비밀번호가 일치하지 않습니다'),
  role: yup
    .string()
    .required('회원 유형을 선택해주세요')
    .oneOf(['teacher', 'instructor', 'staff'], '유효한 회원 유형을 선택해주세요'),
  roleInfo: yup.object({
    phoneNumber: yup
      .string()
      .required('휴대폰 번호를 입력해주세요')
      .trim(),
    organization: yup
      .string()
      .when('$role', {
        is: 'teacher',
        then: (schema) => schema.trim(),
        otherwise: (schema) => schema.notRequired()
      }),
    subject: yup
      .string()
      .trim(),
    experience: yup
      .string()
      .trim(),
    address: yup
      .string()
      .trim(),
    department: yup
      .string()
      .when('$role', {
        is: 'staff',
        then: (schema) => schema.trim(),
        otherwise: (schema) => schema.notRequired()
      }),
    staffPosition: yup
      .string()
      .when('$role', {
        is: 'staff',
        then: (schema) => schema.trim(),
        otherwise: (schema) => schema.notRequired()
      })
  }).required()
}).required();

// 수업 생성 검증 스키마
export const lessonSchema = yup.object({
  title: yup
    .string()
    .required('수업 제목을 입력해주세요')
    .min(3, '제목은 최소 3자 이상이어야 합니다')
    .max(100, '제목은 최대 100자까지 입력 가능합니다')
    .trim(),
  description: yup
    .string()
    .required('수업 설명을 입력해주세요')
    .min(10, '설명은 최소 10자 이상이어야 합니다')
    .max(500, '설명은 최대 500자까지 입력 가능합니다')
    .trim(),
  category: yup
    .string()
    .required('카테고리를 선택해주세요'),
  chapter: yup
    .string()
    .required('챕터를 선택해주세요'),
  topic: yup
    .string()
    .required('토픽을 선택해주세요'),
  contents: yup
    .array()
    .min(1, '최소 1개 이상의 콘텐츠를 선택해주세요')
    .required('콘텐츠를 선택해주세요')
}).required();

// 사용자 정보 수정 검증 스키마
export const userUpdateSchema = yup.object({
  name: yup
    .string()
    .required('이름을 입력해주세요')
    .min(2, '이름은 최소 2자 이상이어야 합니다')
    .max(50, '이름은 최대 50자까지 입력 가능합니다')
    .trim(),
  email: yup
    .string()
    .required('이메일을 입력해주세요')
    .email('유효한 이메일 주소를 입력해주세요')
    .trim(),
  organization: yup
    .string()
    .trim(),
  position: yup
    .string()
    .trim(),
  department: yup
    .string()
    .trim()
}).required();

// 비밀번호 변경 검증 스키마
export const passwordChangeSchema = yup.object({
  currentPassword: yup
    .string()
    .required('현재 비밀번호를 입력해주세요'),
  newPassword: yup
    .string()
    .required('새 비밀번호를 입력해주세요')
    .min(8, '비밀번호는 최소 8자 이상이어야 합니다')
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)/,
      '비밀번호는 영문자와 숫자를 포함해야 합니다'
    )
    .notOneOf([yup.ref('currentPassword')], '새 비밀번호는 현재 비밀번호와 달라야 합니다'),
  confirmNewPassword: yup
    .string()
    .required('새 비밀번호 확인을 입력해주세요')
    .oneOf([yup.ref('newPassword')], '비밀번호가 일치하지 않습니다')
}).required();

// 문의하기 검증 스키마
export const inquirySchema = yup.object({
  name: yup
    .string()
    .required('이름을 입력해주세요')
    .min(2, '이름은 최소 2자 이상이어야 합니다')
    .trim(),
  email: yup
    .string()
    .required('이메일을 입력해주세요')
    .email('유효한 이메일 주소를 입력해주세요')
    .trim(),
  subject: yup
    .string()
    .required('제목을 입력해주세요')
    .min(3, '제목은 최소 3자 이상이어야 합니다')
    .max(100, '제목은 최대 100자까지 입력 가능합니다')
    .trim(),
  message: yup
    .string()
    .required('메시지를 입력해주세요')
    .min(10, '메시지는 최소 10자 이상이어야 합니다')
    .max(1000, '메시지는 최대 1000자까지 입력 가능합니다')
    .trim()
}).required();
